// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicVerifyRouteImport } from './routes/_public/verify'
import { Route as PublicLenderRouteImport } from './routes/_public/lender'
import { Route as PublicInvestorRouteImport } from './routes/_public/investor'
import { Route as ProtectedExampleProtectedRouteRouteImport } from './routes/_protected/example-protected-route'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignOutRouteImport } from './routes/_auth/sign-out'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as PublicFarmerFarmerIdRouteImport } from './routes/_public/farmer.$farmerId'

const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const PublicVerifyRoute = PublicVerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => PublicRoute
          })
const PublicLenderRoute = PublicLenderRouteImport.update({
            id: '/lender',path: '/lender',getParentRoute: () => PublicRoute
          })
const PublicInvestorRoute = PublicInvestorRouteImport.update({
            id: '/investor',path: '/investor',getParentRoute: () => PublicRoute
          })
const ProtectedExampleProtectedRouteRoute = ProtectedExampleProtectedRouteRouteImport.update({
            id: '/example-protected-route',path: '/example-protected-route',getParentRoute: () => ProtectedRoute
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          })
const AuthSignOutRoute = AuthSignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => AuthRoute
          })
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const PublicFarmerFarmerIdRoute = PublicFarmerFarmerIdRouteImport.update({
            id: '/farmer/$farmerId',path: '/farmer/$farmerId',getParentRoute: () => PublicRoute
          })





const AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignInRoute: AuthSignInRoute,AuthSignOutRoute: AuthSignOutRoute,AuthSignUpRoute: AuthSignUpRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const ProtectedRouteChildren = {
  ProtectedExampleProtectedRouteRoute: ProtectedExampleProtectedRouteRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)




const PublicRouteChildren = {
  PublicInvestorRoute: PublicInvestorRoute,PublicLenderRoute: PublicLenderRoute,PublicVerifyRoute: PublicVerifyRoute,PublicIndexRoute: PublicIndexRoute,PublicFarmerFarmerIdRoute: PublicFarmerFarmerIdRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,ProtectedRoute: ProtectedRouteWithChildren,PublicRoute: PublicRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)